import http from "./base";



class PaymentService{
    constructor(){}

    async onboardUser(user) {
        const url = 'payments/onboardUser/'+user;
        await http
            .post(url, {},{
              headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(response  => {
                sessionStorage.setItem('chargesEnabled',response.data.user.chargesEnabled); 
                sessionStorage.setItem('stripeAccountCreated',response.data.user.stripeAccountCreated);    
               window.location.href = response.data.url
            })
            .catch(error => {
              console.log(error.response.data);
              throw new Error(`HTTP error! status: ${error.response.data}`);
            });
    }

    async handleStripeCallback(code, state) {
  const url = 'payments/handleStripeCallback';

  await http
    .get(url, {
      params: {
        code,
        state
      },
      headers: {
        authorization: 'Bearer ' + sessionStorage.getItem('token')
      }
    })
    .then(response => {
      sessionStorage.setItem('chargesEnabled', response.data.user.chargesEnabled);
      sessionStorage.setItem('stripeAccountCreated', response.data.user.stripeAccountCreated);
    })
    .catch(error => {
      console.log(error.response?.data || error.message);
      throw new Error(`HTTP error! status: ${error.response?.data || error.message}`);
    });
}


    async connectUser(userID) {
        const url = 'payments/connectStripeAccount/';
        await http
            .post(url, {userID},{
              headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(response  => {
               window.location.href = response.data.url
            })
            .catch(error => {
              console.log(error.response.data);
              throw new Error(`HTTP error! status: ${error.response.data}`);
            });
    }

     async deauthorizeStripeAccount(userID) {
        const url = 'users/deauthorizeStripeAccount';
        var response = "";
        await http
            .post(url, {userID},{
              headers: {
                    authorization: 'Bearer ' + sessionStorage.getItem('token')
                  },
            })
            .then(responseData  => {
                response = responseData.data
            })
            .catch(error => {
              console.log(error.response.data);
              throw new Error(`HTTP error! status: ${error.response.data}`);
            });

            return response
    }


}

let service = new PaymentService();
export default service;



